import { Record as record } from 'immutable';
import { construct, fields, resolveAll } from '../../../src/helpers/LinkMapper';

const defaults = {
    id: null,
    isBankable: null,
    requiresAccount: null,
    countries: null,
    isOtherType: null,
    message: null,
    disabled: false
};

export default class DelayRepayPaymentMethod extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(DelayRepayPaymentMethod, json, {
            id: fields.string,
            isBankable: fields.bool,
            requiresAccount: fields.bool,
            countries: resolveAll.with(String),
            isOtherType: fields.bool,
            message: fields.string,
            disabled: fields.bool
        });
    }

    isAllowedForCustomer(customer) {
        if (this.countries && !this.countries.isEmpty()) {
            const country = customer.address.country;
            return this.countries.includes(country);
        }
        return true;
    }
}
